import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './DiagnosticStyles.css';
import CircularLoader from "@common/CircularLoader";
import {COL_DEFS, defaultPDFParams, GridStyle, GRID_ENUMS, COL_WIDTH, AGGREGATE_LEVELS, FB_MESSAGES} from "./Styles";
import {AgGridReact} from "ag-grid-react";
import {addStudentColDefs, showHideUserCols, sortColumns} from "./Utils";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {printDoc} from "./pdfExport/printDoc";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import axios from "@common/axios";

const GroupByAggregateView = props => {
    const {
        isDiagnostic,
        isLoading,
        setLoading,
        testAssignmentsData,
        students,
        studentIds,
        selectedTestIds,
        studentColOrder,
        selectedDifficultyIds,
        selectedAggregateLevel,
        contentType,
        openDialogCallback,
        triggerGenerate
    } = props;

    const syllabusRowSpan = params => {
        if (params.data.syllabusRowSpan) {
            return params.data.syllabusRowSpan;
        }
    }

    const topicRowSpan = params => {
        if (params.data.topicRowSpan) {
            return params.data.topicRowSpan;
        }
    }

    const conceptRowSpan = params=>{
        if(params.data.conceptRowSpan){
            return params.data.conceptRowSpan;
        }
    }

    const curriculumKey = ['curriculumSyllabusId','curriculumTopicId','curriculumConceptId','skillId'],
        textKey = ['syllabusId','topicId','conceptId','skillId'],
        rowHeight = 36,
        REPORT_NAME = 'ClassAggregateReport',
        NAME = 'NAME',
        syllabusCol = {field:'syllabus',headerName:'Course', testExamName:'Unit'},
        topicCol = {field:'topic',headerName:'Chapter', testExamName:'Area of Study'},
        conceptCol = {field:'concept',headerName:'Topic', testExamName:'Sub-topic'},
        skillCol = {field:'skill',headerName:'Skill', testExamName:'Skill'},
        ID = 'ID',
        defaultColDef = COL_DEFS.defaultColDef,
        correctColDef = {...COL_DEFS.correctColDef},
        syllabusColDef = {
            resizable:true,
            cellClassRules: {
                'content-span-cell': 'value !== undefined'
            },rowSpan:syllabusRowSpan, columnType:GRID_ENUMS.CONTENT, wrapText: true,headerClass:'text-center-align margin-top-40', cellStyle:{textAlign:'left',overflow:'auto',wordBreak:'break-word',lineHeight:'16px', display:'flex'}, width:COL_WIDTH.MEDIUM, field: syllabusCol.field, headerName: isDiagnostic ? syllabusCol.headerName : syllabusCol.testExamName, pinned:'left', pinnedOrder: 0
        },
        topicColDef = {
            resizable:true,
            cellClassRules: {
                'content-span-cell': 'value !== undefined'
            },rowSpan:topicRowSpan, columnType:GRID_ENUMS.CONTENT, wrapText: true,headerClass:'text-center-align margin-top-40', cellStyle:{textAlign:'left',overflow:'auto',wordBreak:'break-word',lineHeight:'16px', display:'flex'}, width:COL_WIDTH.MEDIUM, field: topicCol.field, headerName: isDiagnostic ? topicCol.headerName : topicCol.testExamName, pinned:'left', pinnedOrder: 1
        },
        conceptColDef = {
            resizable:true,
            cellClassRules: {
                'content-span-cell': 'value !== undefined'
            },rowSpan:conceptRowSpan, columnType:GRID_ENUMS.CONTENT, wrapText: true, headerClass:'text-center-align margin-top-40', cellStyle:{textAlign:'left',overflow:'auto',wordBreak:'break-word',lineHeight:'16px', display:'flex'}, width:COL_WIDTH.MEDIUM, field: conceptCol.field, headerName: isDiagnostic ? conceptCol.headerName : conceptCol.testExamName, pinned:'left', pinnedOrder: 2
        },
        skillColDef = {
            resizable:true,
            cellClassRules: {
                'content-span-cell': 'value !== undefined'
            },wrapText: true, columnType:GRID_ENUMS.CONTENT, headerClass:'text-center-align margin-top-40', cellStyle:{wordBreak:'break-word',lineHeight:'16px',overflow:'auto', display:'flex'}, width:COL_WIDTH.BIGGER, field: skillCol.field, headerName: isDiagnostic ? skillCol.headerName : skillCol.testExamName, pinned:'left', pinnedOrder: 3
        },
        curriculumNames = [
            {fieldName:syllabusCol.field, propName:'curriculumSyllabusName',type:NAME},
            {fieldName:topicCol.field, propName:'curriculumTopicName',type:NAME},
            {fieldName:conceptCol.field, propName:'curriculumConceptName',type:NAME},
            {fieldName:skillCol.field, propName:'skillName',type:NAME}
        ],
        textNames = [
            {fieldName:syllabusCol.field, propName:'syllabusName',type:NAME},
            {fieldName:topicCol.field, propName:'topicName',type:NAME},
            {fieldName:conceptCol.field, propName:'conceptName',type:NAME},
            {fieldName:skillCol.field, propName:'skillName',type:NAME}
        ],
        curriculumFieldIds= [
            {fieldName:'conceptId', propName:'curriculumConceptId',type:ID},
            {fieldName:'topicId', propName:'curriculumTopicId',type:ID},
            {fieldName:'syllabusId', propName:'curriculumSyllabusId',type:ID},
            {fieldName:'skillId', propName:'skillId',type:ID}
        ],
        textFieldIds = [
            {fieldName:'conceptId', propName:'conceptId',type:ID},
            {fieldName:'topicId', propName:'topicId',type:ID},
            {fieldName:'syllabusId', propName:'syllabusId',type:ID},
            {fieldName:'skillId', propName:'skillId',type:ID}
        ],
        aggregateLevels = {
            skill:{
                curriculum: {
                    key:curriculumKey,
                    fields:[
                        ...curriculumNames,
                        ...curriculumFieldIds
                    ]},
                text: {
                    key:textKey,
                    fields:[
                        ...textNames,
                        ...textFieldIds
                    ]
                }
            },
            concept:{
                curriculum: {
                    key: curriculumKey.slice(0, 3),
                    fields: curriculumNames.slice(0, 3).concat(curriculumFieldIds.slice(0, 3))
                },
                text: {key:textKey.slice(0,3),
                    fields: textNames.slice(0,3).concat(textFieldIds.slice(0,3))
                }
            },
            topic:{
                curriculum: {
                    key: curriculumKey.slice(0, 2),
                    fields: curriculumNames.slice(0, 2).concat(curriculumFieldIds.slice(0, 2))

                },
                text: {
                    key: textKey.slice(0,2),
                    fields: textNames.slice(0,2).concat(textFieldIds.slice(0, 2))
                }
            },
            syllabus:{
                curriculum: {
                    key: curriculumKey.slice(0, 1),
                    fields: curriculumNames.slice(0, 1).concat(curriculumFieldIds.slice(0, 1))
                },
                text: {
                    key:textKey.slice(0,1),
                    fields: textNames.slice(0,1).concat(textFieldIds.slice(0, 1))
                }
            }
        }

    //remove sortable function for aggregate view
    delete correctColDef.sortable;
    delete correctColDef.unSortIcon;

    const gridRef = useRef(),
        [aggregateFieldNames,setAggregateFieldNames] = useState([]),
        [testResults,setTestResults] = useState([]),
        [questionResults,setQuestionResults] = useState([]),
        [viewData, setViewData] =  useState([]),
        // [unfilteredData, setUnfilteredData] =  useState([]),
        [headerHeightOffset,setHeaderHeightOffset] = useState(0),
        [graphData, setGraphData] =  useState(null),
        [columnDefs,setColumnDefs] = useState([]);

    useEffect(()=>{
        if(selectedTestIds === undefined || selectedTestIds.length === 0 || testAssignmentsData.length === 0){
            return;
        }
        setGraphData(null);
        setLoading(true);

        if(testAssignmentsData.length > 0){
            let tempQuestionResults = [],
                tempTestResults = [];

            testAssignmentsData.forEach((testAssignmentData) => {
                if(testAssignmentData.questionResultBeans != undefined) {
                    tempQuestionResults = [...tempQuestionResults, ...testAssignmentData.questionResultBeans];
                    tempTestResults = [...tempTestResults, ...testAssignmentData.testResultBeans];
                }
            });

            setTestResults(tempTestResults);
            setQuestionResults(tempQuestionResults);
            setLoading(false);
        }else{
            setLoading(false);
        }
    },[triggerGenerate]);

    const initCols = [syllabusColDef,topicColDef,conceptColDef,skillColDef,correctColDef];

    useEffect(()=>{
        if(students.length > 0) {
            addStudentColDefs(students, initCols,false, openDialogCallback);
        }
        setColumnDefs(initCols);
    },[students]);

    useEffect(()=>{
        showHideUserCols(gridRef,columnDefs,studentIds);
    },[studentIds]);


    useEffect(()=>{
        let columns = [...columnDefs];
        if(columns.length === 0){
            return;
        }
        let sortedColumns = sortColumns(columns, studentColOrder);
        // setLoading(false);
        setColumnDefs(sortedColumns);
        showHideAggregateCols();
    },[studentColOrder,graphData]);

    useEffect(()=>{
        if(questionResults.length > 0){
            mapQuestionResults();
        }

    },[questionResults, testResults, contentType, selectedDifficultyIds, selectedAggregateLevel]);

    const mapQuestionResults = ()=>{
        setGraphData(null);
        const aggregateLevel = aggregateLevels[selectedAggregateLevel][contentType];
        let aggregateMap = {};
        let aggregateLastRowMap = {syllabus:'', topic:'', concept:'', skill:'', correctPercent:GRID_ENUMS.NOT_AVAILABLE,correctPercentVal:0};
        let userTotals = {};
        questionResults.forEach(questionResult =>{
            if(selectedDifficultyIds.length === 0 || selectedDifficultyIds.includes(questionResult.questionDiffLevel)){
                const userKey = GRID_ENUMS.USER+questionResult.userId;
                let key = '';
                aggregateLevel.key.forEach(id=>{
                    key+=questionResult[id];
                });
                if(!aggregateMap.hasOwnProperty(key)){
                    aggregateMap[key] = {questionMaxMark:0, questionMarkTotal:0};
                }
                if(!aggregateMap[key].hasOwnProperty(userKey)){
                    aggregateMap[key][userKey] = {questionMark:0,count:0,questionMaxMark:0,percent:0};
                }

                if(!userTotals.hasOwnProperty(questionResult.userId)){
                    userTotals[questionResult.userId] = {userKey:userKey, userMarks:0, userMaxMarks:0};
                }

                aggregateMap[key][userKey].questionMark += questionResult.mark ? questionResult.mark : 0;

                const questionMaxMark = questionResult.adaptiveMaxMark !== 0 ? questionResult.adaptiveMaxMark : questionResult.maxMark;
                aggregateMap[key][userKey].questionMaxMark += questionMaxMark;
                aggregateMap[key].questionMarkTotal += questionResult.mark ? questionResult.mark : 0;
                aggregateMap[key].questionMaxMark += questionMaxMark;

                userTotals[questionResult.userId].userMarks += questionResult.mark ? questionResult.mark : 0;
                userTotals[questionResult.userId].userMaxMarks += questionMaxMark;
                userTotals[questionResult.userId].performance = 100 * userTotals[questionResult.userId].userMarks/userTotals[questionResult.userId].userMaxMarks;

                const totalStudentValue = Math.round(100 * aggregateMap[key].questionMarkTotal / aggregateMap[key].questionMaxMark);
                const rowPercentValue = aggregateMap[key].questionMaxMark !== 0 ? totalStudentValue : 0;
                aggregateMap[key][GRID_ENUMS.CORRECT_PERCENT_VALUE] = rowPercentValue;
                aggregateMap[key][GRID_ENUMS.CORRECT_PERCENT] = rowPercentValue+'%';

                const studentValue = Math.round(100 * aggregateMap[key][userKey].questionMark / aggregateMap[key][userKey].questionMaxMark);
                const percentValue = aggregateMap[key][userKey].questionMaxMark !== 0 ? studentValue : 0;
                aggregateMap[key][userKey].percent = percentValue;
                aggregateMap[key][userKey].percentDisplay = percentValue+'%';
                aggregateMap[key][userKey].count++;

                aggregateLevel.fields.forEach(field=>{
                    aggregateMap[key][field.fieldName] = questionResult[field.propName];
                })
            }
        });

        const aggregateData = [...Object.values(aggregateMap)];
        const userTotalsArr = [...Object.values(userTotals)];

        userTotalsArr.forEach(userTotal =>{
            aggregateLastRowMap[userTotal.userKey] = Math.round(100 * userTotal.userMarks / userTotal.userMaxMarks) + '%';
        });

        columnDefs.forEach(column =>{
            if(column.columnType === GRID_ENUMS.USER){
                if(userTotals.hasOwnProperty(column.userId) && userTotals[column.userId].hasOwnProperty('performance')){
                    column.performance = userTotals[column.userId].performance;
                    column.answered = true;
                }else{
                    column.performance = 0;
                    column.answered = false;
                }
            }
        });

        aggregateData.forEach(dataRow=>{
            students.forEach(student=>{
                if(dataRow.hasOwnProperty(GRID_ENUMS.USER+student.userId)){
                    dataRow[GRID_ENUMS.USER+student.userId] = dataRow[GRID_ENUMS.USER+student.userId].percentDisplay;
                }
            });
        })

        let syllabusIndexMap = {},
            topicIndexMap = {},
            conceptIndexMap = {};
        const aggregateLevelFieldNames = [];
        aggregateLevel.fields.forEach(field => {
            if(field.type === NAME){
                aggregateLevelFieldNames.push(field.fieldName);
            }
        });

        if(aggregateLevelFieldNames.includes(skillCol.field)){
            aggregateLastRowMap.skill = 'Student TOTAL';
        }else if(aggregateLevelFieldNames.includes(conceptCol.field)){
            aggregateLastRowMap.concept = 'Student TOTAL';
        }else if(aggregateLevelFieldNames.includes(topicCol.field)){
            aggregateLastRowMap.topic = 'Student TOTAL';
        }else{
            aggregateLastRowMap.syllabus = 'Student TOTAL';
        }

        aggregateData.forEach((dataRow,idx)=>{
            if(aggregateLevelFieldNames.includes(syllabusCol.field)) {
                addToMap(syllabusIndexMap, dataRow.syllabusId, idx, syllabusCol.field);
            }
            if(aggregateLevelFieldNames.includes(topicCol.field)){
                addToMap(topicIndexMap,dataRow.topicId,idx);
            }
            if(aggregateLevelFieldNames.includes(conceptCol.field)) {
                addToMap(conceptIndexMap, dataRow.conceptId, idx);
            }

        });

        const syllabusIndexArr = [...Object.values(syllabusIndexMap)],
            topicIndexArr = [...Object.values(topicIndexMap)],
            conceptIndexArr = [...Object.values(conceptIndexMap)];

        if(aggregateLevelFieldNames.includes(syllabusCol.field)) {
            mapRowSpan(syllabusIndexArr, aggregateData, AGGREGATE_LEVELS.SYLLABUS);
        }
        if(aggregateLevelFieldNames.includes(topicCol.field)) {
            mapRowSpan(topicIndexArr, aggregateData, AGGREGATE_LEVELS.TOPIC);
        }
        if(aggregateLevelFieldNames.includes(conceptCol.field)) {
            mapRowSpan(conceptIndexArr, aggregateData, AGGREGATE_LEVELS.CONCEPT);
        }

        // add last row only if there is data for the rest of the rows.
        if(aggregateData.length > 0){
            aggregateData.push(aggregateLastRowMap)
        }
        setViewData(aggregateData);
        setAggregateFieldNames(aggregateLevelFieldNames);
    }

    const showHideAggregateCols = ()=> {
        if (gridRef && gridRef.current && gridRef.current.api) {
            columnDefs.forEach(column => {
                if (column.columnType === GRID_ENUMS.CONTENT) {
                    gridRef.current.api.setColumnsVisible([column.field], aggregateFieldNames.includes(column.field))
                }
            });
        }
    }

    const mapRowSpan = (indexArr, aggregateData, property)=>{
        indexArr.forEach(indexData =>{
            let count = 0;
            for(let i = indexData.startIdx; count < indexData.count; count++){
                if(count!==0){
                    delete aggregateData[i][property];
                }else{
                    aggregateData[i][property+'RowSpan'] = indexData.count;
                }
                i++;
            }
        });
    }

    const addToMap = (map,key,idx)=>{
        if(!map.hasOwnProperty(key)){
            map[key] = {startIdx:idx,count:1}
        }else{
            map[key].count++;
        }
    }

    useEffect(()=>{
        setGraphData(viewData);
    },[viewData]);

    useEffect(()=>{
        showHideUserCols(gridRef,columnDefs,studentIds);
    },[studentIds]);

    const onGridReady = ()=>{
        // console.log('ON GRID READY');
        showHideAggregateCols();
        showHideUserCols(gridRef,columnDefs,studentIds);
        setLoading(false);
    }

    const onExportCSV = useCallback(() => {
        gridRef.current.api.exportDataAsCsv({fileName:REPORT_NAME});
    }, []);

    const onExportPDF = useCallback(() => {
        printDoc(defaultPDFParams,gridRef.current.api,REPORT_NAME);
    }, []);

    const getToolBar = () => (
        <div className="export-toolbar genBtn-blk">
            <button type="button" className="btn btn-default excel genBtn smallBtn"
                    onClick={onExportCSV}
            >Export CSV <FileDownloadIcon/>
            </button>
            <button type="button" className="btn btn-default reset genBtn smallBtn"
                    onClick={onExportPDF}
            >Export PDF <FileDownloadIcon/>
            </button>
        </div>
    );

    return(
        <div>
            {!isLoading && graphData && graphData.length > 0 && getToolBar() }
            {graphData && graphData.length > 0 &&
                <div id="order-by-aggregate-view"  className="ag-theme-balham" style={{height:(rowHeight*graphData.length+GridStyle.VERTICAL_HEADER_HEIGHT+GridStyle.GRID_PADDING_SML+GridStyle.HORIZONTAL_SCROLLBAR_PADDING-Math.abs(headerHeightOffset))+'px',marginTop:Math.abs(headerHeightOffset)}}>
                    <AgGridReact
                        ref={gridRef}
                        suppressPropertyNamesCheck={true}
                        suppressHorizontalScroll={true}
                        suppressRowTransform={true}
                        defaultColDef={defaultColDef}
                        rowHeight={rowHeight}
                        headerHeight={GridStyle.VERTICAL_HEADER_HEIGHT}
                        columnDefs={columnDefs}
                        rowData={graphData}
                        onGridReady={onGridReady}
                        // onCellClicked={handleCellClick}
                    />
                </div>
            }
        </div>
    )
}

export default GroupByAggregateView;
